import React from 'react';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { commonMessages } from '../../../../../../common/messages';
import { messages } from './messages';

export type AvatarErrorModalProps = {
	errorMessage: string;
	onClose: () => void;
};

export const AvatarErrorModal = ({ errorMessage, onClose }: AvatarErrorModalProps) => {
	const { formatMessage } = useIntl();

	return (
		<Modal width="small">
			<ModalHeader>
				<ModalTitle>{formatMessage(commonMessages.avatarPickerModalHeader)}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Box paddingBlock="space.1000" xcss={ModalContentStyle}>
					<Stack space="space.200" alignInline="center" alignBlock="center">
						<ErrorIcon label="" color={token('color.icon.warning')} LEGACY_size="xlarge" />
						<Box paddingInline="space.600">
							<Text align="center">{errorMessage}</Text>
						</Box>
					</Stack>
				</Box>
			</ModalBody>
			<ModalFooter>
				<Button onClick={onClose}>
					{formatMessage(messages.avatarErrorModalGoBackButtonTitle)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};

const ModalContentStyle = xcss({
	textAlign: 'center',
});
